export interface Team {
  id: string;
  name: string;
  description?: string;
  logoUrl?: string;
  isPublic?: boolean;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
}
